//
//
//
//
//
//
//
//

export default {
  name: 'TopicInPost',
  created() {

  },
  props: ['topic'],
  data() {
    return {
    }
  },
  methods: {
    goToTopic: function() {
      this.$router.push({ name: 'topic', params: { id: this.topic.objectId } })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/post/TopicInPost.vue